import { render, staticRenderFns } from "./nav-menu.vue?vue&type=template&id=6d88dca5&scoped=true"
import script from "./nav-menu.vue?vue&type=script&lang=js"
export * from "./nav-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88dca5",
  null
  
)

export default component.exports